import React from 'react';
import PropTypes from 'prop-types';
import Money from '../../../common/money';

const TipButton = ({ amount, label, ...props }) => (
  <button
    className="c-tipping-view-button"
    type="button"
    data-automation-id={`button:tip:${label || amount}`}
    {...props}
  >
    <div className="c-tipping-view-button__title">
      {label || <Money>{amount}</Money>}
    </div>
    <div className="c-tipping-view-button__description" display-if={amount && label}>
      <Money>{amount}</Money>
    </div>
  </button>
);
TipButton.propTypes = {
  amount: PropTypes.number,
  label: PropTypes.string,
};
TipButton.defaultProps = {
  amount: null,
  label: '',
};

export default TipButton;
